/** Format decimal-string minor units without converting the amount to a floating point number. */
export function financeMoney(value: string, currency: string): string {
  if (!/^[0-9]+$/.test(value) || !/^[A-Z]{3}$/.test(currency)) return "Unavailable";
  const digits =
    new Intl.NumberFormat("en", { style: "currency", currency }).resolvedOptions().maximumFractionDigits ?? 2;
  const padded = value.padStart(digits + 1, "0");
  const whole = digits ? padded.slice(0, -digits) : padded;
  const fraction = digits ? `.${padded.slice(-digits)}` : "";
  return `${currency} ${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}${fraction}`;
}
